import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Document, Page, pdfjs } from 'react-pdf';

import { useNavigate, Link } from "react-router-dom";
import { Page as ShopifyPage, 
         PageActions, 
         FormLayout, 
         Card, 
         BlockStack, 
         Text, 
         Divider,
         TextField,
         ChoiceList,
         Checkbox,
         Select,
         DataTable,
         Tabs,
         Layout,
         ButtonGroup,
         Grid,
         Button,
         Box,
         DescriptionList,
         List,
         ColorPicker,
         hsbToHex
       } from '@shopify/polaris';
import {
  SaveIcon
} from '@shopify/polaris-icons';

import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import PageFooter from '../partials/PageFooter';
import TemplateLineOrderContainer from './TemplateLineOrderContainer';
import PresetSection from './PresetSection';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { createBarcodeTemplate, previewBarcodeTemplate } from '../../redux/actions/barcodeTemplates';

const NewTemplateForm = ({ shopUrl, payload, newBarcodeTemplate, barcodeTemplates, newTemplate, loadPreview, requiresRefresh }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;
  let navigate = useNavigate();

  const [tabSelected, setTabSelected] = useState(0);
  const [lineOptions, setLineOptions] = useState([
    {
      label: 1, value: 0
    },
    {
      label: 2, value: 1
    },
    {
      label: 3, value: 2
    },
    {
      label: 4, value: 3
    }
  ]);

  const [tabs, setTabs] = useState([
    {
      id: 'line-1',
      content: 'Line 1',
      panelId: 0
    },
    {
      id: 'line-2',
      content: 'Line 2',
      panelId: 1,
    },
    {
      id: 'line-3',
      content: 'Line 3',
      panelId: 2,
    },
    {
      id: 'line-4',
      content: 'Line 4',
      panelId: 3,
    }
  ]);

  const handleTabChange = (selectedTabIndex) => {
    setTabSelected(selectedTabIndex);
  }

  const [submitted, setSubmitted] = useState(false);

  const [validTemplate, setValidTemplate] = useState(true);
  const [validationErrors, setValidationErrors] = useState([]);

  const [templateSaved, setTemplateSaved] = useState(true);
  const [templateForm, setTemplateForm] = useState({
    line_settings: [
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        text_color: {
          hue: 120,
          brightness: 0,
          saturation: 1,
        },
        text_color_hex: '000000',
        position: 0
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        text_color: {
          hue: 120,
          brightness: 0,
          saturation: 1,
        },
        text_color_hex: '000000',
        position: 1
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        text_color: {
          hue: 120,
          brightness: 0,
          saturation: 1,
        },
        text_color_hex: '000000',
        position: 2
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        text_color: {
          hue: 120,
          brightness: 0,
          saturation: 1,
        },
        text_color_hex: '000000',
        position: 3
      }
    ],

    page_definition: {
      page_width: 8.5,
      page_length: 11,
      page_x_margin: 0.25,
      page_y_margin: 0.25,
      rows: 15,
      columns: 3,
      label_x_padding: 0.1,
      label_y_padding: 0.1
    },

    barcode_enabled: true,
    barcode_line: 0,
    barcode_height_percent: 50,
    barcode_symbol_enabled: false,
    barcode_symbol_line: 3,
    barcode_symbol_priority: 7,
    barcode_symbol_label_enabled: false,
    barcode_symbol_label_override: '',

    sku_enabled: false,
    sku_line: 3,
    sku_priority: 9,
    sku_label_enabled: false,
    sku_label_override: '',

    product_name_enabled: false,
    product_name_line: 1,
    product_name_priority: 3,
    product_name_label_enabled: false,
    product_nameLabelOverride: '',
    option_1_enabled: false,
    option_1_line: 2,
    option_1_priority: 4,
    option_1_label_enabled: false,
    option_1_label_override: '',
    option_2_enabled: false,
    option_2_line: 2,
    option_2_priority: 5,
    option_2_label_enabled: false,
    option_2_label_override: '',
    option_3_enabled: false,
    option_3_line: 2,
    option_3_priority: 6,
    option_3_label_enabled: false,
    option_3_label_override: '',
    price_enabled: false,
    price_line: 2,
    price_priority: 2,
    price_label_enabled: false,
    price_label_override: '',
    brand_enabled: false,
    brand_line: 1,
    brand_priority: 0,
    brand_label_enabled: false,
    brand_label_override: '',
    rotate: false,
    print_type: 'roll',
    length: 1,
    width: 3,
    size_measurement: 'in',

    store_logo_enabled: false,
    store_logo_line: 0,
    store_logo_height_percent: 50,

    arbitrary_text_enabled: false,
    arbitrary_text_line: 0,
    arbitrary_text_priority: 8,
    arbitrary_text_label_enabled: false,
    arbitrary_text_label_override: '',
  });

  const [templateName, setTemplateName] = useState('');
  const [rotate, setRotate] = useState(false);
  const [printType, setPrintType] = useState('roll');
  const [length, setLength] = useState(1);
  const [width, setWidth] = useState(3);
  const [sizeMeasurement, setSizeMeasurement] = useState('in');

  const [lineCount, setLineCount] = useState(4);
  const [lineSettings, setLineSettings] = useState([
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      text_color: {
        hue: 120,
        brightness: 0,
        saturation: 1,
      },
      text_color_hex: '000000',
      position: 0
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      text_color: {
        hue: 120,
        brightness: 0,
        saturation: 1,
      },
      position: 1
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      text_color: {
        hue: 120,
        brightness: 0,
        saturation: 1,
      },
      text_color_hex: '000000',
      position: 2
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      text_color: {
        hue: 120,
        brightness: 0,
        saturation: 1,
      },
      text_color_hex: '000000',
      position: 3
    }
  ]);

  const [pageWidth, setPageWidth] = useState(8.5);
  const [pageLength, setPageLength] = useState(11);
  const [pageXMargin, setPageXMargin] = useState(0.25);
  const [pageYMargin, setPageYMargin] = useState(0.25);
  const [pageRows, setPageRows] = useState(15);
  const [pageColumns, setPageColumns] = useState(3);
  const [pageLabelXPadding, setPageLabelXPadding] = useState(0.1);
  const [pageLabelYPadding, setPageLabelYPadding] = useState(0.1);

  const [barcodeEnabled, setBarcodeEnabled] = useState(true);
  const [barcodeLine, setBarcodeLine] = useState(0);
  const [barcodeHeightPercent, setBarcodeHeightPercent] = useState(50);

  const [storeLogoEnabled, setStoreLogoEnabled] = useState(false);
  const [storeLogoLine, setStoreLogoLine] = useState(0);
  const [storeLogoHeightPercent, setStoreLogoHeightPercent] = useState(50);

  const [barcodeSymbolEnabled, setBarcodeSymbolEnabled] = useState(false);
  const [barcodeSymbolLine, setBarcodeSymbolLine] = useState(3);
  const [barcodeSymbolPriority, setBarcodeSymbolPriority] = useState(7);
  const [barcodeSymbolLabelEnabled, setBarcodeSymbolLabelEnabled] = useState(false);
  const [barcodeSymbolLabelOverride, setBarcodeSymbolLabelOverride] = useState('');

  const [skuEnabled, setSkuEnabled] = useState(false);
  const [skuLine, setSkuLine] = useState(3);
  const [skuPriority, setSkuPriority] = useState(8);
  const [skuLabelEnabled, setSkuLabelEnabled] = useState(false);
  const [skuLabelOverride, setSkuLabelOverride] = useState('');

  const [productNameEnabled, setProductNameEnabled] = useState(false);
  const [productNameLine, setProductNameLine] = useState(1);
  const [productNamePriority, setProductNamePriority] = useState(3);
  const [productNameLabelEnabled, setProductNameLabelEnabled] = useState(false);
  const [productNameLabelOverride, setProductNameLabelOverride] = useState('');

  const [optionOneEnabled, setOptionOneEnabled] = useState(false);
  const [optionOneLine, setOptionOneLine] = useState(2);
  const [optionOnePriority, setOptionOnePriority] = useState(4);
  const [optionOneLabelEnabled, setOptionOneLabelEnabled] = useState(false);
  const [optionOneLabelOverride, setOptionOneLabelOverride] = useState('');

  const [optionTwoEnabled, setOptionTwoEnabled] = useState(false);
  const [optionTwoLine, setOptionTwoLine] = useState(2);
  const [optionTwoPriority, setOptionTwoPriority] = useState(5);
  const [optionTwoLabelEnabled, setOptionTwoLabelEnabled] = useState(false);
  const [optionTwoLabelOverride, setOptionTwoLabelOverride] = useState('');

  const [optionThreeEnabled, setOptionThreeEnabled] = useState(false);
  const [optionThreeLine, setOptionThreeLine] = useState(2);
  const [optionThreePriority, setOptionThreePriority] = useState(6);
  const [optionThreeLabelEnabled, setOptionThreeLabelEnabled] = useState(false);
  const [optionThreeLabelOverride, setOptionThreeLabelOverride] = useState('');

  const [priceEnabled, setPriceEnabled] = useState(false);
  const [priceLine, setPriceLine] = useState(2);
  const [pricePriority, setPricePriority] = useState(2);
  const [priceLabelEnabled, setPriceLabelEnabled] = useState(false);
  const [priceLabelOverride, setPriceLabelOverride] = useState('');

  const [brandEnabled, setBrandEnabled] = useState(false);
  const [brandLine, setBrandLine] = useState(1);
  const [brandPriority, setBrandPriority] = useState(0);
  const [brandLabelEnabled, setBrandLabelEnabled] = useState(false);
  const [brandLabelOverride, setBrandLabelOverride] = useState('');

  const [arbitraryTextEnabled, setArbitraryTextEnabled] = useState(false);
  const [arbitraryTextLine, setArbitraryTextLine] = useState(3);
  const [arbitraryTextPriority, setArbitraryTextPriority] = useState(8);
  const [arbitraryTextLabelEnabled, setArbitraryTextLabelEnabled] = useState(true);
  const [arbitraryTextLabelOverride, setArbitraryTextLabelOverride] = useState('');

  const [activePreviewuri, setActivePreviewUri] = useState(null);

  const [previewGenerating, setPreviewGenerating] = useState(false);
  const [enqueuePreviewGeneration, setEnqueuePreviewGeneration] = useState(null);

  useEffect(() => {
    handlePreview(templateForm, null);
  }, []);

  useEffect(() => {
    if(newTemplate) { navigate(-1) };
  }, [newTemplate]);

  useEffect(() => {
    let updatedTemplate = templateForm;
    updatedTemplate['line_settings'] = lineSettings;

    handlePreview(updatedTemplate, null);
  }, [lineSettings]);

  const changeLineCount = (event) => {
    let updatedTemplate = templateForm;
    let updatedLineSettings = lineSettings;

    let newLineCount = parseInt(event);
    let newLineOptions = [];
    let newTabs = [];

    let isIncrease = newLineCount > (lineCount || 0);

    if(isIncrease) {
      let difference = newLineCount - (lineCount || 0);

      for(let i = 0; i < difference; i++){
        updatedLineSettings.push({
          render_strategy: 'truncate',
          font_size: 12,
          alignment: 'left',
          text_color: {
            hue: 120,
            brightness: 0,
            saturation: 1,
          },
          text_color_hex: '000000',
          position: (lineCount || 0) + i
        })
      }
    } else {
      let difference = (lineCount || 0) - newLineCount;

      for(let i = 0; i < difference; i++){
        updatedLineSettings.pop();
      }
    }

    for (let i = 0; i < newLineCount; i++) {
      newLineOptions.push({
        label: i + 1, value: i
      });

      newTabs.push({
        id: `line-${i + 1}`,
        content: `Line ${i + 1}`,
        panelId: i
      })
    }

    setLineCount(newLineCount);
    setLineOptions(newLineOptions);
    setTabs(newTabs);

    updatedTemplate['line_count'] = newLineCount;
    updatedTemplate['line_settings'] = updatedLineSettings;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const setNumeric = (setField, event, templateId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = event.replace(/[^\d.-]+/g, '');

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    setField(valueNumeric);
    updatedTemplate[templateId] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const setInteger = (setField, event, templateId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = parseInt(event) || 0;

    if(valueNumeric > 99) {
      valueNumeric = 99
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    setField(valueNumeric);
    updatedTemplate[templateId] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const switchBoolean = (setField, field, key) => {
    let updatedTemplate = templateForm;
    updatedTemplate[key] = !field;

    setField(!field);
    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const handleSwitchRotate = () => {
    let updatedTemplate = templateForm;
    updatedTemplate['rotate'] = !rotate;

    setRotate(!rotate);
    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
    
    handlePreview(updatedTemplate, null);
  }

  const setMeasurements = (measurement) => {
    let updatedTemplate = templateForm;
    updatedTemplate['size_measurement'] = measurement;

    setTemplateForm(updatedTemplate);

    setSizeMeasurement(measurement);

    handlePreview(updatedTemplate, null);
    setTemplateSaved(false);
  }

  const setFieldValue = (setField, value, templateId) => {
    let updatedTemplate = templateForm;
    updatedTemplate[templateId] = value;
    setTemplateForm(updatedTemplate);
    setField(value);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const setPriority = (updatedTemplate, setFunction, value, key) => {
    setFunction(value);

    updatedTemplate[key] = value;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    // handlePreview(updatedTemplate, null);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    newBarcodeTemplate(shopUrl, payload, templateForm);
    setTemplateSaved(true);
  }

  const handlePreview = (templateForm, values) => {
    validateTemplate(templateForm);

    if(!previewGenerating && !barcodeTemplates.isPreviewFetching) {
      setPreviewGenerating(true);
      setEnqueuePreviewGeneration(null);
      loadPreview(shopUrl, payload, templateForm, values);
    } else {
      setEnqueuePreviewGeneration(templateForm);
    }
  }

  const readyPreview = () => {
    setPreviewGenerating(false);
    if(enqueuePreviewGeneration) {
      handlePreview(enqueuePreviewGeneration, null);
    }
  }

  const flashPageFields = () => {
    let widthElement = document.querySelector('#width-field');
    let lengthElement = document.querySelector('#length-field');
    let measurementsElement = document.querySelector('#measurements-field');
    let pageElements = document.querySelector('#page-fields');

    widthElement.classList.add("blink-action");
    lengthElement.classList.add("blink-action");
    measurementsElement.classList.add("blink-action");
    pageElements.classList.add("blink-action");

    setTimeout(() => {
      widthElement.classList.remove("blink-action");
      lengthElement.classList.remove("blink-action");
      measurementsElement.classList.remove("blink-action");
      pageElements.classList.remove("blink-action");
    }, 1000);
  }

  const setRenderStrategy = (position, value) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, render_strategy: value } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setFontSize = (position, value) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, font_size: value.replace(/[^\d-]+/g, '') } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setAlignment = (position, value) => {
    let updatedTemplate = templateForm;

    console.log(value[0]);

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, alignment: value[0] } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setTextColor = (position, value) => {
    console.log(value);
    console.log(hsbToHex(value));

    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, text_color: value, text_color_hex: hsbToHex(value) } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const increasePriority = (element, lineElements) => {
    let updatedTemplate = templateForm;

    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === 0) { return; }

    let el = lineElements[elementIndex - 1];
    let elementNewPriority = lineElements[elementIndex - 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementNewPriority, 'sku_priority') }
    if(element.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementNewPriority, 'price_priority') }
    if(element.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementOldPriority, 'sku_priority') }
    if(el.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementOldPriority, 'price_priority') }
    if(el.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    handlePreview(updatedTemplate, null);

    let titleElement = document.querySelector(`#ordering-title-${elementNewPriority}`);
    let rowElement = document.querySelector(`#ordering-row-${elementNewPriority}`);

    titleElement.classList.add("blink-action");
    rowElement.classList.add("blink-action");

    setTimeout(() => {
      titleElement.classList.remove("blink-action");
      rowElement.classList.remove("blink-action");
    }, 1000);
  }
  
  const decreasePriority = (element, lineElements) => {
    let updatedTemplate = templateForm;

    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === (lineElements.length - 1)) { return; }

    let el = lineElements[elementIndex + 1];
    let elementNewPriority = lineElements[elementIndex + 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementNewPriority, 'sku_priority') }
    if(element.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementNewPriority, 'price_priority') }
    if(element.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementOldPriority, 'sku_priority') }
    if(el.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementOldPriority, 'price_priority') }
    if(el.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    handlePreview(updatedTemplate, null);

    let titleElement = document.querySelector(`#ordering-title-${elementNewPriority}`);
    let rowElement = document.querySelector(`#ordering-row-${elementNewPriority}`);

    titleElement.classList.add("blink-action");
    rowElement.classList.add("blink-action");

    setTimeout(() => {
      titleElement.classList.remove("blink-action");
      rowElement.classList.remove("blink-action");
    }, 1000);
  }

  const setPageValue = (setField, event, fieldId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = event.replace(/[^\d.-]+/g, '') || 0.0;

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    let valueInteger = parseInt(event) || 0;

    if(['rows', 'columns'].includes(fieldId)) {
      setField(valueInteger);
      updatedTemplate['page_definition'][fieldId] = valueInteger;
    } else {
      setField(valueNumeric);
      updatedTemplate['page_definition'][fieldId] = parseFloat(valueNumeric);
    }

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    validateTemplate(updatedTemplate);
  }

  const handleSwitchPageType = (newType) => {
    let updatedTemplate = templateForm;

    updatedTemplate['print_type'] = newType;
    setPrintType(newType);

    if (newType === 'sheet') {
      setRotate(false);
      updatedTemplate['rotate'] = false;
    }

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const validateTemplate = (templateForm) => {
    let valid = true;
    let updatedValidationErrors = [];

    // Must have a template name
    if (!templateForm['template_name']) {
      valid = false;
      updatedValidationErrors.push('Template name missing.');
    }

    // Must have label lengths and widths
    if (!templateForm['width'] ||  !templateForm['length']) {
      valid = false;
      updatedValidationErrors.push('Templates must have defined label length and width');
    }

    // If it's a sheet, it must have page length, page width, rows and columns
    if (templateForm['print_type'] === 'sheet') {
      if (!templateForm.page_definition.page_length || !templateForm.page_definition.page_width || !templateForm.page_definition.columns || !templateForm.page_definition.rows) {
        valid = false;
        updatedValidationErrors.push('Sheets must have defined page length, page width, columns and rows.');
      }
    }

    setValidationErrors(updatedValidationErrors);
    setValidTemplate(valid);
  }

  const barcodeRow = [
    [
      <Checkbox
        checked={barcodeEnabled}
        onChange={() => switchBoolean(setBarcodeEnabled, barcodeEnabled, 'barcode_enabled')}
      />,
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setBarcodeLine, e, 'barcode_line')}
        value={barcodeLine}
      />,
      <TextField type="number" value={barcodeHeightPercent} label="" onChange={(e) => setNumeric(setBarcodeHeightPercent, e, 'barcode_height_percent')} autoComplete="off" />
    ]
  ]

  // const storeLogoRow = [
  //   [
  //     <Checkbox
  //       checked={storeLogoEnabled}
  //       onChange={() => switchBoolean(setStoreLogoEnabled, storeLogoEnabled, 'store_logo_enabled')}
  //     />,
  //     <Select
  //       options={lineOptions}
  //       onChange={(e) => setInteger(setStoreLogoLine, e, 'store_logo_line')}
  //       value={storeLogoLine}
  //     />,
  //     <TextField type="number" value={storeLogoHeightPercent} label="" onChange={(e) => setNumeric(setStoreLogoHeightPercent, e, 'store_logo_height_percent')} autoComplete="off" />
  //   ]
  // ]

  const arbitraryTextRow = [
    [
      <Checkbox
        checked={arbitraryTextEnabled}
        onChange={() => switchBoolean(setArbitraryTextEnabled, arbitraryTextEnabled, 'arbitrary_text_enabled')}
      />,
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setArbitraryTextLine, e, 'arbitrary_text_line')}
        value={arbitraryTextLine}
      />,
      <TextField value={arbitraryTextLabelOverride || ''} label="" onChange={(e) => setFieldValue(setArbitraryTextLabelOverride, e, 'arbitrary_text_label_override')} autoComplete="off" />
    ]
  ]

  const labelPartRows = [
    [
      <Checkbox
        checked={barcodeSymbolEnabled}
        onChange={() => switchBoolean(setBarcodeSymbolEnabled, barcodeSymbolEnabled, 'barcode_symbol_enabled')}
      />,
      'Barcode Symbol',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setBarcodeSymbolLine, e, 'barcode_symbol_line')}
        value={barcodeSymbolLine}
      />,
      <Checkbox
        checked={barcodeSymbolLabelEnabled}
        onChange={() => switchBoolean(setBarcodeSymbolLabelEnabled, barcodeSymbolLabelEnabled, 'barcode_symbol_label_enabled')}
      />,
      <TextField value={barcodeSymbolLabelOverride || ''} label="" onChange={(e) => setFieldValue(setBarcodeSymbolLabelOverride, e, 'barcode_symbol_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={skuEnabled}
        onChange={() => switchBoolean(setSkuEnabled, skuEnabled, 'sku_enabled')}
      />,
      'SKU',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setSkuLine, e, 'sku_line')}
        value={skuLine}
      />,
      <Checkbox
        checked={skuLabelEnabled}
        onChange={() => switchBoolean(setSkuLabelEnabled, skuLabelEnabled, 'sku_label_enabled')}
      />,
      <TextField value={skuLabelOverride || ''} label="" onChange={(e) => setFieldValue(setSkuLabelOverride, e, 'sku_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={productNameEnabled}
        onChange={() => switchBoolean(setProductNameEnabled, productNameEnabled, 'product_name_enabled')}
      />,
      'Product Name',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setProductNameLine, e, 'product_name_line')}
        value={productNameLine}
      />,
      <Checkbox
        checked={productNameLabelEnabled}
        onChange={() => switchBoolean(setProductNameLabelEnabled, productNameLabelEnabled, 'product_name_label_enabled')}
      />,
      <TextField value={productNameLabelOverride || ''} label="" onChange={(e) => setFieldValue(setProductNameLabelOverride, e, 'product_name_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={optionOneEnabled}
        onChange={() => switchBoolean(setOptionOneEnabled, optionOneEnabled, 'option_1_enabled')}
      />,
      'Variant Option 1',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setOptionOneLine, e, 'option_1_line')}
        value={optionOneLine}
      />,
      <Checkbox
        checked={optionOneLabelEnabled}
        onChange={() => switchBoolean(setOptionOneLabelEnabled, optionOneLabelEnabled, 'option_1_label_enabled')}
      />,
      <TextField value={optionOneLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionOneLabelOverride, e, 'option_1_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={optionTwoEnabled}
        onChange={() => switchBoolean(setOptionTwoEnabled, optionTwoEnabled, 'option_2_enabled')}
      />,
      'Variant Option 2',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setOptionTwoLine, e, 'option_2_line')}
        value={optionTwoLine}
      />,
      <Checkbox
        checked={optionTwoLabelEnabled}
        onChange={() => switchBoolean(setOptionTwoLabelEnabled, optionTwoLabelEnabled, 'option_2_label_enabled')}
      />,
      <TextField value={optionTwoLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionTwoLabelOverride, e, 'option_2_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={optionThreeEnabled}
        onChange={() => switchBoolean(setOptionThreeEnabled, optionThreeEnabled, 'option_3_enabled')}
      />,
      'Variant Option 3',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setOptionThreeLine, e, 'option_3_line')}
        value={optionThreeLine}
      />,
      <Checkbox
        checked={optionThreeLabelEnabled}
        onChange={() => switchBoolean(setOptionThreeLabelEnabled, optionThreeLabelEnabled, 'option_3_label_enabled')}
      />,
      <TextField value={optionThreeLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionThreeLabelOverride, e, 'option_3_label_override')} autoComplete="off" />
    ],
    [
      <Checkbox
        checked={priceEnabled}
        onChange={() => switchBoolean(setPriceEnabled, priceEnabled, 'price_enabled')}
      />,
      'Price',
      <Select
        options={lineOptions}
        onChange={(e) => setInteger(setPriceLine, e, 'price_line')}
        value={priceLine}
      />,
      <Checkbox
        checked={priceLabelEnabled}
        onChange={() => switchBoolean(setPriceLabelEnabled, priceLabelEnabled, 'price_label_enabled')}
      />,
      <TextField value={priceLabelOverride || ''} label="" onChange={(e) => setFieldValue(setPriceLabelOverride, e, 'price_label_override')} autoComplete="off" />
    ]
    // [
    //   <Checkbox
    //     checked={brandEnabled}
    //     onChange={() => switchBoolean(setBrandEnabled, brandEnabled, 'brand_enabled')}
    //   />,
    //   'Brand',
    //   <Select
    //     options={lineOptions}
    //     onChange={(e) => setInteger(setBrandLine, e, 'brand_line')}
    //     value={brandLine}
    //   />,
    //   <Checkbox
    //     checked={brandLabelEnabled}
    //     onChange={() => switchBoolean(setBrandLabelEnabled, brandLabelEnabled, 'brand_label_enabled')}
    //   />,
    //   <TextField value={brandLabelOverride || ''} label="" onChange={(e) => setFieldValue(setBrandLabelOverride, e, 'brand_label_override')} autoComplete="off" />
    // ]
  ]

  if(barcodeTemplates.isFetching || submitted) {
    return(
      <ShopifyPage
        title="New Label Template"
        primaryAction={<Button icon={SaveIcon} disabled variant="primary" onClick={() => handleSubmit()}>Save Template</Button>}
        backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/templates' + window.location.search}}
      >
        { requiresRefresh &&
          <RequiresRefreshBanner />
        }
        <LoadingPlaceholder />
      </ShopifyPage>
    )
  }

  return(
    <ShopifyPage
      title="New Label Template"
      primaryAction={<Button icon={SaveIcon} disabled={validationErrors.length > 0} variant="primary" onClick={() => handleSubmit()}>Save Template</Button>}
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/templates' + window.location.search}}
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      <Layout>
        <Layout.Section>
          <FormLayout>
            <BlockStack gap="400">
              <Card>
                <BlockStack gap="200">
                  <Text variant="headingLg" as="h5">Label Template Options</Text>
                  <DescriptionList
                    items={[
                      {
                        term: 'Template name',
                        description:
                          <TextField value={templateName} onChange={(e) => setFieldValue(setTemplateName, e, 'template_name')} autoComplete="off" />,
                      },
                      {
                        term: 'Print Type',
                        description:  <>
                                        <ButtonGroup variant="segmented">
                                          <Button pressed={printType==='roll'} onClick={() => handleSwitchPageType('roll')}>
                                            Roll
                                          </Button>
                                          <Button pressed={printType==='sheet'} onClick={() => handleSwitchPageType('sheet')}>
                                            Sheet
                                          </Button>
                                        </ButtonGroup>
                                        { printType === 'roll' &&
                                          <Checkbox
                                            label="Rotate Labels"
                                            checked={rotate}
                                            onChange={() => handleSwitchRotate()}
                                          />
                                        }
                                      </>,
                      },
                      {
                        term: <Box id='measurements-field'><Text>Label Measurement Units</Text></Box>,
                        description:
                          <ChoiceList
                            choices={[
                              {label: 'in', value: 'in'},
                              {label: 'cm', value: 'cm'},
                              {label: 'mm', value: 'mm'},
                            ]}
                            selected={sizeMeasurement}
                            onChange={(e) => setMeasurements(e)}
                          />,
                      },
                      {
                        term: 
                          <Box id='width-field'><Text>Label Width</Text></Box>,
                        description:
                          <TextField type="number" value={width} onChange={(e) => setNumeric(setWidth, e, 'width')} autoComplete="off" />
                      },
                      {
                        term: <Box id='length-field'><Text>Label Length</Text></Box>,
                        description:
                          <TextField type="number" value={length} onChange={(e) => setNumeric(setLength, e, 'length')} autoComplete="off" />,
                      },
                      {
                        term: 'Line Count',
                        description:
                          <TextField type="number" value={lineCount || ''} onChange={(e) => setInteger(changeLineCount, e, 'line_count')} autoComplete="off" />,
                      },
                    ]}
                  />

                  { printType === 'sheet' &&
                    <>
                      <Divider />
                      <Text variant="headingLg" as="h5">Page Options</Text>
                      <FormLayout.Group condensed>

                        <Grid>
                          <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
                            <PresetSection
                              setTemplateForm={setTemplateForm}
                              templateForm={templateForm}
                              setLength={setLength}
                              setWidth={setWidth}
                              setPageWidth={setPageWidth}
                              setPageLength={setPageLength}
                              setPageXMargin={setPageXMargin}
                              setPageYMargin={setPageYMargin}
                              setPageRows={setPageRows}
                              setPageColumns={setPageColumns}
                              setPageLabelXPadding={setPageLabelXPadding}
                              setPageLabelYPadding={setPageLabelYPadding}
                              setSizeMeasurement={setSizeMeasurement}
                              handlePreview={handlePreview}
                              flashPageFields={flashPageFields}
                            />
                          </Grid.Cell>

                          <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
                            <Box id='page-fields'>
                              <TextField type="number" value={pageWidth} label="Page Width" onChange={(e) => setPageValue(setPageWidth, e, 'page_width')} autoComplete="off" />
                              <TextField type="number" value={pageLength} label="Page Length" onChange={(e) => setPageValue(setPageLength, e, 'page_length')} autoComplete="off" />

                              <TextField type="number" value={pageXMargin} label="X Margin" onChange={(e) => setPageValue(setPageXMargin, e, 'page_x_margin')} autoComplete="off" />
                              <TextField type="number" value={pageYMargin} label="Y Margin" onChange={(e) => setPageValue(setPageYMargin, e, 'page_y_margin')} autoComplete="off" />

                              <TextField type="number" value={pageRows} label="Page Rows" onChange={(e) => setPageValue(setPageRows, e, 'rows')} autoComplete="off" />
                              <TextField type="number" value={pageColumns} label="Page Columns" onChange={(e) => setPageValue(setPageColumns, e, 'columns')} autoComplete="off" />

                              <TextField type="number" value={pageLabelXPadding} label="Label X Padding" onChange={(e) => setPageValue(setPageLabelXPadding, e, 'label_x_padding')} autoComplete="off" />
                              <TextField type="number" value={pageLabelYPadding} label="Label Y Padding" onChange={(e) => setPageValue(setPageLabelYPadding, e, 'label_y_padding')} autoComplete="off" />
                            </Box>
                          </Grid.Cell>
                        </Grid>

                      </FormLayout.Group>
                    </>
                  }
                  
                </BlockStack>
              </Card>

              <Card>
                <BlockStack gap="200">
                  <Text variant="headingLg" as="h5">Full Line Options</Text>

                  <DescriptionList
                    items={[
                      {
                        term: 'Barcode Line',
                        description:
                          <DataTable
                            columnContentTypes={[
                              'text',
                              'text',
                              'text'
                            ]}
                            headings={[
                              'Enabled',
                              'Line',
                              'Height % of label'
                            ]}
                            rows={barcodeRow}
                          />,
                      }
                    ]}
                  />

                  

                  {/*<Text>Store Logo Line</Text>
                  <DataTable
                    columnContentTypes={[
                      'text',
                      'text',
                      'text'
                    ]}
                    headings={[
                      'Enabled',
                      'Line',
                      'Height % of label'
                    ]}
                    rows={storeLogoRow}
                  />*/}

                  <Divider />

                  <DescriptionList
                    items={[
                      {
                        term: 'Branding Text Line',
                        description:
                          <DataTable
                            columnContentTypes={[
                              'text',
                              'text',
                              'text'
                            ]}
                            headings={[
                              'Enabled',
                              'Line',
                              'Text'
                            ]}
                            rows={arbitraryTextRow}
                          />,
                      }
                    ]}
                  />
                  
                </BlockStack>
              </Card>

              <Card>
                <BlockStack gap="200">
                  <Text variant="headingLg" as="h5">Label Line Parts</Text>
                  <DataTable
                    columnContentTypes={[
                      'text',
                      'text',
                      'text',
                      'text',
                      'text'
                    ]}
                    headings={[
                      'Enabled',
                      'Label Part',
                      'Line',
                      'Include Name',
                      'Name Override'
                    ]}
                    rows={labelPartRows}
                  />
                </BlockStack>
              </Card>

              <Card>
                <BlockStack gap="200">
                  <Text variant="headingLg" as="h5">Line Settings</Text>
                  <Tabs tabs={tabs} selected={tabSelected} onSelect={handleTabChange} fitted>
                    { lineSettings.map((lineSetting, index) =>
                        <>
                          { tabs[tabSelected].panelId === index && 
                            <BlockStack gap="200">

                              <DescriptionList
                                items={[
                                  {
                                    term: 'Text Overflow Strategy',
                                    description:
                                      <ChoiceList
                                        choices={[
                                          {label: 'Truncate', value: 'truncate'},
                                          {label: 'Wrap', value: 'wrap'},
                                          {label: 'Shrink-To-Fit', value: 'shrink'},
                                        ]}
                                        selected={lineSetting.render_strategy}
                                        onChange={(e) => setRenderStrategy(lineSetting.position, e)}
                                      />,
                                  },
                                  {
                                    term: 'Text Placement',
                                    description:
                                      <ChoiceList
                                        choices={[
                                          {label: 'Align Left', value: 'left'},
                                          {label: 'Align Center', value: 'center'},
                                          {label: 'Align Right', value: 'right'},
                                        ]}
                                        selected={lineSetting.alignment}
                                        onChange={(e) => setAlignment(lineSetting.position, e)}
                                      />,
                                  },
                                  {
                                    term: 'Font Size',
                                    description:
                                      <TextField type="number" value={lineSetting.font_size || ''} onChange={(e) => setFontSize(lineSetting.position, e)} autoComplete="off" />,
                                  },
                                  {
                                    term: 'Text Color',
                                    description:
                                    <>
                                      { printType !== 'roll' &&
                                        <ColorPicker 
                                          onChange={(e) => setTextColor(lineSetting.position, e)} 
                                          color={lineSetting.text_color} 
                                        />
                                      }
                                      { printType === 'roll' &&
                                        <Text>Labels printed from sheets can have text colors when using a printer with color ink. Rolls are printed on thermal printers and can only be black and white.</Text>
                                      }
                                    </>
                                  }
                                ]}
                              />

                              <Divider />

                              <TemplateLineOrderContainer
                                barcode={barcodeEnabled && (index === barcodeLine)}
                                storeLogo={storeLogoEnabled && (index === storeLogoLine)}

                                barcodeSymbol={barcodeSymbolEnabled && (index === barcodeSymbolLine)}
                                sku={skuEnabled && (index === skuLine)}
                                productName={productNameEnabled && (index === productNameLine)}
                                optionOne={optionOneEnabled && (index === optionOneLine)}
                                optionTwo={optionTwoEnabled && (index === optionTwoLine)}
                                optionThree={optionThreeEnabled && (index === optionThreeLine)}
                                price={priceEnabled && (index === priceLine)}
                                brand={brandEnabled && (index === brandLine)}
                                arbitraryText={arbitraryTextEnabled && (index === arbitraryTextLine)}

                                barcodeSymbolPriority={barcodeSymbolPriority}
                                skuPriority={skuPriority}
                                productNamePriority={productNamePriority}
                                optionOnePriority={optionOnePriority}
                                optionTwoPriority={optionTwoPriority}
                                optionThreePriority={optionThreePriority}
                                pricePriority={pricePriority}
                                brandPriority={brandPriority}
                                arbitraryTextPriority={arbitraryTextPriority}

                                increasePriority={increasePriority}
                                decreasePriority={decreasePriority}
                              />

                            </BlockStack>
                          }
                        </>
                      )
                    }
                  </Tabs>
                </BlockStack>
              </Card>
            </BlockStack>
          </FormLayout>
        </Layout.Section>

        <Layout.Section variant="oneThird">
          <BlockStack gap="200">
            <Card background="bg-surface-info">
              <Text variant="headingLg" as="h5">Preview</Text>
              <Box background="bg-surface-info">
                { barcodeTemplates.previewUri &&
                  <Document className="pdf-document" file={{ url: barcodeTemplates.previewUri }} loading={<LoadingSpinner size="small" statusText="Loading Preview" />} onLoadSuccess={() => readyPreview()}>
                    <Page
                      className="pdf-page"
                      pageNumber={1} 
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                }
                { barcodeTemplates.errors &&
                  <Text tone="critical">
                    Failed to load preview
                  </Text>
                }
              </Box>
            </Card>

            { (validationErrors.length > 0) &&
              <Card background="bg-surface-critical">
                <Text variant="headingLg" as="h5">Template Errors</Text>
                  <List type="bullet">
                    { validationErrors.map((error, index) =>
                      <List.Item key={index}>
                        {error} 
                      </List.Item>
                    )}
                  </List>
              </Card>
            }
          </BlockStack>
        </Layout.Section>
      </Layout>

      <PageActions
        primaryAction={<Button icon={SaveIcon} disabled={validationErrors.length > 0} variant="primary" onClick={() => handleSubmit()}>Save Template</Button>}
      />

      <PageFooter stripeBackground='#5bc6cc' helpLink="shopify/manage-barcode-label-templates-3/" helpDescription="setting up label templates" />
    </ShopifyPage>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  barcodeTemplates: state.barcodeTemplates,
  newTemplate: state.barcodeTemplates.newTemplate,
});

const mapDispatchToProps = (dispatch) => ({
  newBarcodeTemplate: (shopUrl, payload, options) => dispatch(createBarcodeTemplate(shopUrl, payload, options)),
  loadPreview: (shopUrl, payload, options, values) => dispatch(previewBarcodeTemplate(shopUrl, payload, options, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewTemplateForm);
